export function isOnboardingIdentityVerificationRequired() {
  const raw = import.meta.env.VITE_ONBOARDING_IDENTITY_VERIFICATION_REQUIRED;
  return raw === 'true' ? true : false;
}

export function isProfileRejectedByUserInfo(userInfo?: {
  profile_approval_status?: string | null;
  onboarding_rejection_reason?: string | null;
} | null) {
  return (
    userInfo?.profile_approval_status === 'rejected' ||
    Boolean(userInfo?.onboarding_rejection_reason)
  );
}

